import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';

import './ServiceRequestFormCategory.scss';
import { fetchItems } from '../../store/actions/items';
import { selectItems, selectItemFaqCategoriesByType } from '../../store/selectors/items';
import { selectServiceRequestFormData } from '../../store/selectors/serviceRequestForm';
import { setServiceRequestFormData, setServiceRequestFormNextStep, setServiceRequestFormPreviousStep, setServiceRequestFormStep, exitServiceRequestForm } from '../../store/actions/serviceRequestForm';
import Button from '../Button';
import Col from '../Col';
import Diagnosis from '../Diagnosis/Diagnosis';
import Form from '../Form';
import FontAwesomeIcon from '../Icon';
import Progress from './Progress';
import Row from '../Row';
import { selectFaqByIssueType} from '../../store/selectors/faqsNotesDocuments'
import { selectAuthenticatedUser } from '../../store/selectors/auth';

class ServiceRequestFormCategory extends Component {
  state={
    faqs:[]
  }
  componentDidMount()
  {
    const { onFetchItems,faqsNotesDocuments } = this.props;
    onFetchItems();
    let faqs= faqsNotesDocuments.length>0?faqsNotesDocuments.filter((item)=>item.type==="FAQS"):[]
    let faqData = faqs.length>0?faqs.map((item)=>JSON.parse(item.data)):[]
    this.setState({faqs:faqData})
  }

  render() {
    const { itemFaqCategories, onSetServiceRequestFormData, serviceRequestFormData, onSetServiceRequestFormNextStep, onSetServiceRequestFormStep, onSetServiceRequestFormPreviousStep, onExitServiceRequestForm, onExit, user } = this.props;
    return (
      <Form
        headline="Let’s Identify the Issue"
        strapline="Tell us what’s happening and we’ll  be able to find the right solution to get your home back to normal."
        onClose={onSetServiceRequestFormPreviousStep}
        onExit={() => {
          onExitServiceRequestForm();
          if (onExit) onExit();
        }}
        component={(
          <div className='requestProgress'>
            <Row mdCenter>
            <Col
              xs="12"
              md="6"
            >
              <Diagnosis
                asset={serviceRequestFormData.asset_item_nameDescription}
                issueType={serviceRequestFormData.issueType}
                expiresAt={serviceRequestFormData.assetWarrantyExpiresAt}
              />
              <Progress
                currentStep={2}
                totalSteps={3}
              />
              <div className="service-request-form-category__title">Common Questions</div>
              <div className="service-request-form-category__items" style={{paddingBottom:"3rem"}}>
                {
                  user.roles[0].role.name === 'Home Owner'?
                  this.state.faqs.map(category => (
                    <button
                      key={category.id}
                      className="service-request-form-category__item"
                      onClick={() => {
                        onSetServiceRequestFormData({ category: category })
                        onSetServiceRequestFormNextStep()
                      }}
                      type="button"
                    >
                      {category.question}
                      <FontAwesomeIcon
                        weight="light"
                        glyph="chevron-right"
                      />
                    </button>
                  ))
                  :itemFaqCategories.map(category => (
                    <button
                      key={category.id}
                      className="service-request-form-category__item"
                      onClick={() => {
                        onSetServiceRequestFormData({ category: category })
                        onSetServiceRequestFormNextStep()
                      }}
                      type="button"
                    >
                      {category.question}
                      <FontAwesomeIcon
                        weight="light"
                        glyph="chevron-right"
                      />
                    </button>
                  ))
                }
              </div>
            </Col>
          </Row>
          </div>
        )}
        footer={(
      <div style={{position: "fixed",
          bottom: "0",left:'0',
          width: "100%",
          background: "#fff", padding:'15px', boxShadow: '0 0 0.3rem rgba(0, 0, 0, 0.3)'}}>
          <>
            Haven’t found your answer?
            <br />
            <br />
            <Button
              color="teal"
              size="small"
              label="Next: Add Details"
              onClick={() => onSetServiceRequestFormStep(6)}
              // disabled={!serviceRequestFormData.asset}
            />
          </>
          </div>
        )}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const serviceRequestFormData = selectServiceRequestFormData(state);
  return {
    items: selectItems(state),
    itemFaqCategories: selectFaqByIssueType(state,serviceRequestFormData.issueType),
    // itemFaqCategories: selectItemFaqCategoriesByType(state, serviceRequestFormData.asset_item_id, serviceRequestFormData.issueType),
    serviceRequestFormData,
    user: selectAuthenticatedUser(state),
    faqsNotesDocuments:state.faqsNotesDocuments
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  onSetServiceRequestFormData: setServiceRequestFormData,
  onSetServiceRequestFormNextStep: setServiceRequestFormNextStep,
  onSetServiceRequestFormPreviousStep: setServiceRequestFormPreviousStep,
  onSetServiceRequestFormStep: setServiceRequestFormStep,
  onExitServiceRequestForm: exitServiceRequestForm,
  onFetchItems: fetchItems
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequestFormCategory);
